import { NgModule } from '@angular/core';
import { SecuredImageBcmComponent } from '@shared/components/secured-image-bcm/secured-image-bcm.component';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    declarations: [SecuredImageBcmComponent],
    imports: [
        CommonModule,
        MatProgressSpinnerModule
    ],
    exports: [SecuredImageBcmComponent]
})
export class SecuredImageBcmModule {}
